// Utility for Google Analytics (gtag) injection and event tracking

export function ensureGoogleAnalytics(trackingId, onReady) {
  if (!trackingId) return;
  if (!window.gtag) {
    if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${trackingId}"]`)) {
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      gaScript.onload = () => {
        if (typeof onReady === 'function') onReady();
      };
      document.head.appendChild(gaScript);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${trackingId}');
      `;
      document.head.appendChild(inlineScript);
    } else if (typeof onReady === 'function') {
      setTimeout(onReady, 0);
    }
  } else if (typeof onReady === 'function') {
    setTimeout(onReady, 0);
  }
}

export function trackEvent(event, params = {}) {
  if (window.gtag) {
    window.gtag('event', event, params);
  }
}
